import Text from '@atoms/Text';
import Image from '../atoms/Image';

export const interactionsMap = {
  transientThought: {
    color: 'text-interactionIcons-TransientThoughts', name: 'Transient Thoughts'
  },
  talkingTiles: {
    color: 'text-interactionIcons-TalkingTiles', name: 'Talking Tiles'
  },
  pollWithOptions: {
    color: 'text-interactionIcons-PollWithOptions', name: 'Power Polls'
  },
  freeForm: {
    color: 'text-interactionIcons-PollWithOutOptions', name: 'Open-Ended Polls'
  },
  map: {
    color: 'text-interactionIcons-MagicMap', name: 'Magic Maps'
  },
  wordCloud: {
    color: 'text-interactionIcons-WonderWords', name: 'Wonder Words'
  },
  'Quick Questions': {
    color: 'text-interactionIcons-QuickQuestions', name: 'Quick Questions'
  },
  wheel: {
    color: 'text-interactionIcons-ChoiceCircle', name: 'Choice Circle'
  },
  newWheel: {
    color: 'text-interactionIcons-WinnersWheel', name: 'Winning Wheel'
  },
  'PDF Slide': {
    color: 'text-interactionIcons-PdfSlide', name: 'Slide'
  },
  linkLibrary: {
    color: 'text-interactionIcons-linkLibrary', name: 'Link Library'
  },
  emojisEverywhere: {
    color: 'text-interactionIcons-EmojisEverywhere', name: 'Emojis Everywhere'
  },
  textTrack: {
    color: 'text-interactionIcons-TextTrack', name: 'Text Track'
  },
  fantasticFans: {
    color: 'text-interactionIcons-FantasticFans', name: 'Fantastic Fans'
  },
  ratingPolls: {
    color: 'text-interactionIcons-RatingPolls', name: 'Rating Polls'
  },
  multipleChoice: {
    color: 'text-interactionIcons-MultipleChoice', name: 'Multiple Choice'
  },
  quiz: {
    color: 'text-interactionIcons-MultipleChoice', name: 'Quiz'
  },
  leaderboard: {
    color: 'text-interactionIcons-MultipleChoice', name: 'Leaderboard'
  },
  credits: {
    color: 'text-interactionIcons-FantasticFans', name: 'End Credits'
  },
};

const getUrl = (interaction, cache = {}) => {
  let url;
  if (cache[interaction.question_number]) {
    url = cache[interaction.question_number];
  } else {
    url = process.env.NEXT_PUBLIC_BUCKET_URL + interaction.presentation_slide_s3_key;
  }
  return url;
};

const InteractionTooltip = ({ interaction }) => {
  return (
    <>
      {interaction.type !== 'PDF Slide' && (
        <div className='text-left'>
          <Text
            type="h1"
            className={`${interactionsMap[interaction?.type]?.color} text-xs ${interaction?.title?.length && 'mb-1'}`}
          >
            {interactionsMap[interaction?.type]?.name}
          </Text>
          <Text className="text-sm font-normal text-white line-clamp-2 pr-4">
            {interaction?.title || ''}
          </Text>
        </div>
      )}
      {interaction.type === 'PDF Slide' && (
        <>
          <Image src={getUrl(interaction)} className="rounded-lg object-contain w-full h-full" alt="PDF Slide" />
        </>
      )}
    </>
  );
};

export default InteractionTooltip;
